import React from 'react'
import QueueAnim from "rc-queue-anim";
import { OverPack } from "rc-scroll-anim";
import { isMobile } from '@/utils/utils';
// import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
// import { getEnter } from '@/utils'
import "./index.less";
const ProductList = (props) => {
	const { productData, padding = '180px 0' } = props || {};
	const itemRender = (item) => (
		<div className='product-li-left'>
			<div className='li-title-warp'>
				{/* <Texty enter={getEnter} leave={getEnter} className='li-title'>
					{item.title}
				</Texty> */}
				<div className='li-title'>{item.title}</div>
				{ item.title1 && <div className='li-title'>{item.title1}</div> }
				{/* { 
					item.title1 && (
						<Texty enter={getEnter} leave={getEnter} className='li-title'>
							{item.title1}
						</Texty>
					)
				} */}
			</div>
			{/* <Texty type="bottom" mode="sync" className="li-content">
				{item.content}
			</Texty> */}
			<div className='li-content'>{item.content}</div>
		</div>
	)
  return (
		<div className='product-box'>
			{
				productData.map((item, index) => (
					<OverPack key={`queue-${index}`} style={{ minHeight: 90 }} always={true} playScale={[0.2, 0.8]}>
						<QueueAnim
							interval={120}
							leaveReverse
							type="bottom"
							component={"div"}
						>
							<div
								className={`product-li top-move ${index % 2 === 0 ? 'left-item' : 'right-item'}`}
							>
								<div className='product-li-content' style={{ padding }}>
									{
										isMobile() ? (
											<div>
												{ itemRender(item) }
												<img src={item.img} alt="" className='product-li-right' />
											</div>
										) : (
											<>
												{/* <div className='product-li-left'>
													<div className='li-title-warp'>
														<div className='li-title'>{item.title}</div>
														{ item.title1 && <div className='li-title'>{item.title1}</div> }
													</div>
													<div className='li-content'>{item.content}</div>
												</div> */}
												{ itemRender(item) }
												<img src={item.img} alt="" className='product-li-right' />
											</>
										)
									}
								</div>
							</div>
						</QueueAnim>
					</OverPack>
				))
			}
		</div>
  )
}

export default ProductList;
